window._mode='front';window._protocol='https://';window._domain='www.bijouterie-alterego.fr';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/alter-ego/';window._api='/api/v2/';
import Interface from 'theme/index.js';
import Cart from 'assets/shop/components/cart.js';
import Discount from 'assets/shop/components/discount.js';
import Spinner from 'components/spinner.js';


// ###################  CART  ################
(async () => {
    await Interface();


    var spTimeoutPrdtQty = null;

    //window.addEventListener("DOMContentLoaded", (event) => {


        // PLUS MINUS BUTTONS
        if (document.querySelectorAll('.shop-quantity-buttons-cart').length > 0) {
            
            Array.from(document.querySelectorAll('.shop-quantity-buttons-cart')).forEach(e => {

                e.addEventListener('click', event => {

                    event.preventDefault();
                    
                    let el = event.target;
                    if (!el.classList.contains('shop-quantity-buttons-cart')) {
                        el = el.closest('.shop-quantity-buttons-cart');
                    }

                    const target = el.dataset.target;
                    
                    let quantity = new Number(document.getElementById(target).value);

                    if (el.classList.contains('shop-quantity-plus')) {
                        document.getElementById(target).value = quantity + 1;
                    } else if (quantity - 1 >= 1) {
                        document.getElementById(target).value = quantity - 1;
                    }
                    let evt = new Event('change');
                    document.getElementById(target).dispatchEvent(evt);
                });
            });
        }



        // Bind quantities changes for products INPUT
        if (document.querySelectorAll('.shop-cart-quantity').length > 0)
        {

            Array.from(document.querySelectorAll('.shop-cart-quantity')).forEach(e =>
            {

                if (e.nodeName.toLowerCase() === 'input' || e.nodeName.toLowerCase() === 'select')
                {
                    e.addEventListener('change', (event) =>
                    {
                        event.preventDefault();
                    
                        const e = event.target;
                    
                        window.clearTimeout(spTimeoutPrdtQty);
                    
                        spTimeoutPrdtQty = window.setTimeout(() =>
                        {
                            if (e.dataset.oldvalue != e.value)
                            {
                    
                                const id_product = e.dataset.id_product;
                                const id_product_attribute = e.dataset.id_product_attribute;
                                const id_customization = e.dataset.id_customization;
                                let id_key = `${id_product}-${id_product_attribute}`;

                                if (typeof e.dataset.id_key !== 'undefined' && e.dataset.id_key !== null && e.dataset.id_key !== '')
                                {
                                    id_key = e.dataset.id_key;
                                }
                    
                                let quantity = 0;
                                let quantityCust = 0;
                    
                                if (id_customization != '' && id_customization > 0)
                                {
                                    quantityCust = parseInt(document.getElementById(`shop-product-${id_key}-${id_customization}`).value);
                    
                                    // Get all quantity of all customizations
                                    document.querySelectorAll('.shop-cart-quantity-customizable').forEach(e =>
                                    {
                                        if (e.dataset.id_product == id_product && e.dataset.id_product_attribute == id_product_attribute && e.id != 'shop-product-' + id_key + '-' + id_customization)
                                        {
                                            quantity += new Number(parseInt(e.value));
                                        }
                                    });
                                    quantity += quantityCust;
                                }
                                else
                                {
                                    quantity = new Number(parseInt(document.getElementById(`shop-product-${id_key}`).value));
                                }

                                if (id_customization != '' && id_customization > 0)
                                {
                                    document.getElementById(`shop-product-${id_key}-${id_customization}`).value = quantityCust;
                                    // Main product quantity update
                                    if (document.getElementById(`shop-cart-product-quantity-${id_key}`) !== null)
                                    {
                                        document.getElementById(`shop-cart-product-quantity-${id_key}`).value = quantity;
                                    }
                                }
                                else
                                {
                                    document.getElementById(`shop-product-${id_key}`).value =quantity;
                                }
                    
                                Cart.set({
                                    id_product: id_product,
                                    id_product_attribute: id_product_attribute,
                                    id_customization: id_customization,
                                    id_key: id_key,
                                    quantity: quantity,
                                    quantity_customization: quantityCust,
                                    action: 'refresh'
                                });
                                e.setAttribute('data-oldvalue', e.value);
                            }
                        }, 800);
                    
                        return false;
                    });
                }
            });
        }


        // Bind delete button
        if (document.querySelectorAll('.shop-cart-delete:not(.shop-cart-total-delete-discount)').length > 0)
        {
            Array.from(document.querySelectorAll('.shop-cart-delete:not(.shop-cart-total-delete-discount)')).forEach(e =>
            {
                e.addEventListener('click', event =>
                {
                    event.preventDefault();

                    // Utilise currentTarget (le bouton) et non target (peut être un élément enfant comme une icône)
                    const btn = event.currentTarget;
                    const id_product = btn.dataset.id_product;
                    const id_product_attribute = parseInt(btn.dataset.id_product_attribute);
                    const id_key = btn.dataset.id_key;
                    let id_customization = parseInt(btn.dataset.id_customization);
                    if (isNaN(id_customization))
                    {
                        id_customization = '';
                    }
                    let id_gift_voucher = parseInt(btn.dataset.id_gift_voucher);
                    if (isNaN(id_gift_voucher))
                    {
                        id_gift_voucher = '';
                    }
                    Cart.set({
                        id_product: id_product,
                        id_product_attribute: id_product_attribute,
                        id_customization: id_customization,
                        id_key: id_key,
                        id_gift_voucher: id_gift_voucher,
                        quantity: 0,
                        quantity_customization: 0,
                        action: 'refresh'
                    });
                    return false;
                });
            });
        }
        
    //});


    // Stock old values for products quantities
    document.querySelectorAll('.shop-cart-quantity').forEach(e =>
    {
        e.dataset.oldvalue = e.value;
    });




    document.querySelectorAll('.shop-cart-quantity-switch').forEach(e =>
    {

        e.addEventListener('change', () =>
        {

            const id_product = e.dataset.id_product;
            const id_product_attribute = parseInt(e.dataset.id_product_attribute);
            const id_customization = parseInt(e.dataset.id_customization);
            let quantity = new Number(parseInt(0));
            let quantityCust = parseInt(e.value);

            if (id_customization != '' && id_customization > 0 && !isNaN(id_customization))
            {
                // Get all quantity of all customizations
                document.querySelectorAll('.shop-cart-quantity-customizable').forEach(e =>
                {
                    if (e.dataset.id_product == id_product && e.dataset.id_product_attribute == id_product_attribute && e.id != `shop-product-${id_product}-${id_product_attribute}-${id_customization}`)
                    {
                        quantity += new Number(parseInt(e.value));
                    }
                });
                quantity += new Number(quantityCust);
            }
            else
            {
                quantity = new Number(parseInt(document.getElementById(`shop-product-${id_product}-${id_product_attribute}`).value));

                if (!e.tagName.toLowerCase() === 'select')
                {
                    if (e.classList.contains('more'))
                    {
                        quantity += 1;
                    }
                    else
                    {
                        quantity -= 1;
                    }
                }

                if (quantity < 0)
                {
                    quantity = 0;
                }
            }
            Cart.set({
                id_product: id_product,
                id_product_attribute: id_product_attribute,
                id_customization: id_customization,
                quantity: quantity,
                quantity_customization: quantityCust,
                action: 'refresh'
            });
        });
    });




    // Discount code
    if (document.getElementById('shop-cart-discount') !== null)
    {
        document.getElementById('shop-cart-discount-submit').addEventListener('click', async (event) =>
        {
            event.preventDefault();
            Spinner.set({target: event.target, mode: 'button'});
            event.target.disabled = true;
            await Discount.check(document.getElementById('shop-cart-discount').value);
            event.target.disabled = false;
            Spinner.unset(event.target);
        });
    }
    if (document.querySelectorAll('.shop-cart-total-delete-discount').length > 0)
    {
        Array.from(document.querySelectorAll('.shop-cart-total-delete-discount')).forEach(e =>
        {
            e.addEventListener('click', async (event) =>
            {
                event.preventDefault();
                const id = parseInt(event.target.dataset.id);
                if (id > 0)
                {
                    await Discount.Delete(id);
                }
            });
        });
    }

})();